export default __webpack_public_path__ + "static/media/logo_bw.737b0afd.png";